module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "x-2-Chapter-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/GHPPe_ack"
    }
  }, [_vm._v("Acknowledgments")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/GHPPe_int"
    }
  }, [_vm._v("Introduction")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1 How to Hunt Ghosts")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 Central Portland")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 East Portland Communities")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 Vancouver and North Portland")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 Oregon City and Communities South of Portland")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Oregon’s Coastal Communities")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A Sighting Report Form")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B Suggested Reading")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C Films, DVDs, and Videos")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D Internet Resources")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E Special Tours and Events")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GHPPe_apxf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix F History Museums and Historical Societies")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('br')])]), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "Basic-Text-Frame"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45138f5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 72
// module chunks = 0